import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppPageComponent, AppBarComponent, SyncGuardHelper, UserMessageGuard } from "common";
import { DashboardComponent } from "./dashboard.component";
import { UserMenuComponent } from "../../shared/user-menu/user-menu.component";
import { IsLeadCompletedGuard } from "../../shared/guard/lead-completed.guard";
import { AuthGuard } from "../auth/infrastructure/auth.guard";
import { ApplicationAgreementSignedGuard } from "../../shared/guard/application-agreement-signed.guard";
import { PhoneNumberConfirmationReminderComponent } from "common";
import { LoanAgreementSignedGuard } from "../../shared/guard/loan-agreement-signed.guard";
import { CheckoutStateGuard } from "../identity-verification/guards/checkout-state.guard";

const routes: Routes = [
  {
    path: "dashboard",
    component: AppPageComponent,
    data: {
      appBar: {
        logoSize: "logo-s",
        logoIcon: true,
      },
      appPage: {
        contentClass: "simple",
      },
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "right",
            component: UserMenuComponent,
          },
          {
            path: '',
            outlet: 'reminder',
            component: PhoneNumberConfirmationReminderComponent,
          }
        ],
      },
      {
        path: "",
        component: DashboardComponent,
        canActivate: [SyncGuardHelper],
        data: {
            syncGuards: [
            AuthGuard,
            IsLeadCompletedGuard,
            CheckoutStateGuard,
            ApplicationAgreementSignedGuard,
            LoanAgreementSignedGuard,
            UserMessageGuard
          ]
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
